import * as React from 'react';
import { Dispatch } from 'react-redux';

import { StoreState } from '../../../reducers';
import { setActiveItem, toggleEditPanel, updateEditableLink } from '../../../containers/Editor/actions';
import { IGNORE_PAGE_CLICK_CLASS } from '../Page';
import EditPanel from '../../../containers/Editor/EditPanel';
import LinkPanel from '../../../containers/Editor/EditPanel/LinkPanel';
import { EditableType } from '../../../containers/Editor/constants';
import { getBorderWidth } from '../../../containers/Editor/utils/helpers';
import { StyledLinkEditor, IconLink } from './styles';
import Utils from '../../../utils';

interface LinkEditorProps {
	page: number;
	id: string;
	isActive: boolean;
	value: string;
	pageScale: number;
	isEditPanelDisplayed: boolean;
	hasEditableImage: boolean;
	dispatch: Dispatch<StoreState>;
}

const LinkEditor = ({
	page,
	id,
	isActive,
	value,
	pageScale,
	isEditPanelDisplayed,
	hasEditableImage,
	dispatch,
}: LinkEditorProps) => {
	const handleClick = () => {
		if (hasEditableImage) {
			return;
		}

		if (!isActive) {
			dispatch(setActiveItem(id, null));

			if (!isEditPanelDisplayed) {
				dispatch(toggleEditPanel());
			}
		}
	};

	const handleChange = (newValue: string) => {
		if (newValue !== value) {
			dispatch(updateEditableLink(page, id, {
				href: newValue,
			}));
		}
	};

	const renderEditPanel = () => (
		!hasEditableImage && isActive && isEditPanelDisplayed && (
			<EditPanel
				defaultType={EditableType.link}
				panels={{
					[EditableType.link]: (
						<LinkPanel
							value={value}
							onChange={handleChange}
						/>
					),
				}}
			/>
		)
	);

	const editorClasses = Utils.getCssClasses(`${IGNORE_PAGE_CLICK_CLASS} uprez-link-editor`, {
		'is-active': isActive,
		'has-image': hasEditableImage,
	});

	return (
		<>
			<StyledLinkEditor
				className={editorClasses}
				isActive={isActive}
				hasEditableImage={hasEditableImage}
				borderWidth={getBorderWidth(pageScale)}
				onClick={handleClick}
				onTouchEnd={handleClick}
			>
				<IconLink className="uprez-link-editor-icon">
					{Utils.getSvgIcon('iconset_uprez_link')}
				</IconLink>
			</StyledLinkEditor>
			{renderEditPanel()}
		</>
	);
};

export default LinkEditor;



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/Editor/LinkEditor/index.tsx